export const shadows = {
  xs: '0 1px 10px 0 rgba(30, 28, 73, 0.12)', // elevation.1
  sm: '0 4px 18px 0 rgba(30, 28, 73, 0.12), 0px 10px 14px 0 rgba(30, 28, 73, 0.14), 0 6px 6px 0 rgba(30, 28, 73, 0.20)', // elevation.2
  md: '0 6px 30px 0 rgba(30, 28, 73, 0.12), 0px 16px 24px 0 rgba(30, 28, 73, 0.14), 0 8px 10px 0 rgba(30, 28, 73, 0.20)', // elevation.3
  lg: '0 8px 42px 0 rgba(30, 28, 73, 0.12), 0px 22px 35px 0 rgba(30, 28, 73, 0.14), 0 10px 14px 0 rgba(30, 28, 73, 0.20)', // elevation.4
  xl: '0 9px 46px 0 rgba(30, 28, 73, 0.12), 0px 24px 38px 0 rgba(30, 28, 73, 0.14), 0 11px 15px 0 rgba(30, 28, 73, 0.20)', // elevation.5
  xxl: '0 9px 46px 0 rgba(30, 28, 73, 0.12), 0px 24px 38px 0 rgba(30, 28, 73, 0.14), 0 11px 15px 0 rgba(30, 28, 73, 0.20)', // elevation.5
} as const;
